export enum GeofenceType {
  USER_DEFINED = 'user',
  WORLD = 'world',
}
export enum UserGeofenceType {
  CIRCLE = 'CIRCLE',
  POLYGON = 'POLYGON',
}
export enum GeofenceActionType {
  VIOLATION = 'Violation',
  LOG = 'Log',
  ALERT = 'Alert',
}
export enum GeofenceInteractionAction {
  ON_ENTRY = 'onEntry',
  ON_EXIT = 'onExit',
}
